/** @format */

import template from './gb-table-item-compact.html';
import './gb-table-item-compact.scss';

export const GbTableItemCompactComponent = {
    template,
    require: {
        gbWidget: '^^',
        gbItemTableWidget: '^^',
        gbTableItem: '^^',
    },
    bindings: {
        item: '<',
        winningBid: '<',
    },
    controller: class GbTableItemCompactComponent {
        constructor($ccColors) {
            'ngInject';

            this.$ccColors = $ccColors;

            this.styles = {};
        }

        getSecondaryStyles() {
            this.styles['background-color'] = this.gbWidget.widget.table_primary_color;
            this.styles['color'] = this.$ccColors.getContrast(this.styles['background-color']);
            return this.styles;
        }

        hasBids() {
            return !!this.gbTableItem.getBiddingItem() && this.gbTableItem.getBiddingItem().winning_bids.length > 0;
        }
    },
};
